import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import Header from './Header';
import Footer from './Footer';
import { LoginAPI } from '../components/api';

const AdminLogin = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(LoginAPI.adminLogin, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ loginId, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      navigate('/dashboard');
    } catch (error) {
      setError('Invalid ID or password');
    }
  };

  return (
    <>
      <Header />
      <div className="admin-login-container">
        <div className="admin-login-box">
          <h2 className="admin-login-title">Admin Login</h2>
          <form onSubmit={handleLogin} className="admin-login-form">
            <input
              type="text"
              placeholder="Login ID"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className="admin-login-button">Login</button>
            {error && <p className="login-error">{error}</p>}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminLogin;
